const AUTOPAY_ERROR_SCREEN_PREFIX = "autopay-error-screen";

export const AUTOPAY_ERROR_SCREEN_TEST_IDS = {
    TITLE: `${AUTOPAY_ERROR_SCREEN_PREFIX}_title`,
    MESSAGE: `${AUTOPAY_ERROR_SCREEN_PREFIX}_message`,
    IMAGE: `${AUTOPAY_ERROR_SCREEN_PREFIX}_image`,
    CTA: `${AUTOPAY_ERROR_SCREEN_PREFIX}_cta`,
};
